// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';
// import '@react-pdf-viewer/zoom/lib/styles/index.css';
// import { KeenIcon, Modal, ModalBody, ModalContent, ModalHeader, ModalTitle } from '@/components';

// const DocumentPreviewModal = ({
//     open,
//     onClose,
//     fileUrl,
//     loading = false,
//     title = 'Preview Document',
//     zoomPluginInstance,
// }) => {
//     const { ZoomIn, ZoomOut, CurrentScale } = zoomPluginInstance;

//     return (
//         <Modal open={open} onClose={onClose}>
//             <div className="modal-overlay flex items-center justify-center">
//                 <ModalContent className="max-h-[95vh] custom-scrollbar scrollable-y-auto bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light shadow-lg w-4/5 max-w-3xl">
//                     <ModalHeader className="sticky top-0 z-10 bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark]">
//                         <ModalTitle>{title}</ModalTitle>
//                         <button
//                             type="button"
//                             onClick={onClose}
//                             className="text-gray-500 hover:text-gray-700 text-xl"
//                         >
//                             <KeenIcon icon="cross" />
//                         </button>
//                     </ModalHeader>
//                     {fileUrl && (
//                         <div className="flex items-center justify-end gap-2 px-5 pb-2 bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] sticky top-[44px] z-10">
//                             <ZoomIn>
//                                 {(props) => (
//                                     <button
//                                         className="btn btn-xs btn-light"
//                                         onClick={props.onClick}
//                                         disabled={props.isDisabled}
//                                     >
//                                         <KeenIcon icon="plus" />
//                                     </button>
//                                 )}
//                             </ZoomIn>

//                             <CurrentScale>
//                                 {(props) => (
//                                     <span className="text-xs">
//                                         {Math.round(props.scale * 100)}%
//                                     </span>
//                                 )}
//                             </CurrentScale>

//                             <ZoomOut>
//                                 {(props) => (
//                                     <button
//                                         className="btn btn-xs btn-light"
//                                         onClick={props.onClick}
//                                         disabled={props.isDisabled}
//                                     >
//                                         <KeenIcon icon="minus" />
//                                     </button>
//                                 )}
//                             </ZoomOut>
//                         </div>
//                     )}
//                     <ModalBody className="py-2 min-h-[100px]">
//                         {loading ? (
//                             <div className="text-center text-sm">
//                                 Loading Preview...
//                             </div>
//                         ) : fileUrl ? (
//                             <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
//                                 <Viewer
//                                     fileUrl={fileUrl}
//                                     plugins={[zoomPluginInstance]}
//                                     defaultScale={1}
//                                 />
//                             </Worker>
//                         ) : (
//                             <div className="text-center text-sm text-red-500">
//                                 No preview available
//                             </div>
//                         )}
//                     </ModalBody>
//                 </ModalContent>
//             </div>
//         </Modal>
//     );
// };

// export { DocumentPreviewModal };


import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { PDF_WORKER_URL } from '@/config/pdfViewer';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { KeenIcon } from '@/components';

const DocumentPreviewModal = ({
    open,
    onClose,
    fileUrl,
    loading = false,
    title = 'Preview Document',
    zoomPluginInstance,
}) => {
    if (!open) return null;

    const { ZoomIn, ZoomOut, CurrentScale } = zoomPluginInstance;

    return (
        <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50 modal-animate-fade">
            {/* Fills the screen like Google Drive's viewer (OL-185). */}
            <div className="modal-body modal-animate-scale !p-0 !px-5 flex flex-col w-[calc(100vw-2rem)] max-w-6xl h-[calc(100vh-2rem)]">
                {/* Header */}
                <div className="pt-3 shrink-0 bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark]">
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-medium text-gray-900 my-2">
                            {title}
                        </h2>
                        <button
                            type="button"
                            onClick={onClose}
                            className="modal-close-btn"
                        >
                            <KeenIcon icon="cross" />
                        </button>
                    </div>

                    {fileUrl && (
                        <div className="flex items-center justify-end gap-2 pb-2">
                            <ZoomIn>
                                {(props) => (
                                    <button
                                        className="btn btn-xs btn-light"
                                        onClick={props.onClick}
                                        disabled={props.isDisabled}
                                    >
                                        <KeenIcon icon="plus" />
                                    </button>
                                )}
                            </ZoomIn>

                            <CurrentScale>
                                {(props) => (
                                    <span className="text-xs">
                                        {Math.round(props.scale * 100)}%
                                    </span>
                                )}
                            </CurrentScale>

                            <ZoomOut>
                                {(props) => (
                                    <button
                                        className="btn btn-xs btn-light"
                                        onClick={props.onClick}
                                        disabled={props.isDisabled}
                                    >
                                        <KeenIcon icon="minus" />
                                    </button>
                                )}
                            </ZoomOut>
                        </div>
                    )}
                </div>

                {/* Content */}
                <div className="flex-1 min-h-0 pb-2">
                    {loading ? (
                        <div className="h-full flex items-center justify-center text-sm">
                            Loading Preview...
                        </div>
                    ) : fileUrl ? (
                        <Worker workerUrl={PDF_WORKER_URL}>
                            <Viewer
                                fileUrl={fileUrl}
                                plugins={[zoomPluginInstance]}
                                defaultScale={SpecialZoomLevel.PageWidth}
                            />
                        </Worker>
                    ) : (
                        <div className="h-full flex items-center justify-center text-sm text-red-500">
                            No preview available
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export { DocumentPreviewModal };
